import { Transitions } from '../types';

export const transitions: Transitions = {
  normal: 200,
};
